import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import ListSubheader from "@material-ui/core/ListSubheader";
import Divider from "@material-ui/core/Divider";
import { Typography } from "@material-ui/core";
import LinkOptionalEquipment from "../LinkOptionalEquipment";
import { ANSWER_OPTION_LABELS } from "../../../services/form.helper.service";
import { IS_LINK_PROMPT_ENABLED } from "../../../utility/Constant";
import AssignUniqueCode from "../AssignUniqueCode";
import LinkPrompt from "../LinkPrompt";

const useStyles = makeStyles((theme) => ({
  root: {},
  sideNavDivider: {
    marginLeft: 16,
  },
}));

const FileUploaderMenu = React.forwardRef((props, ref) => {
  const classes = useStyles();
  const [popup, setPopup] = useState(false);
  const [assignUniqueCodePopup, setAssignUniqueCodePopup] = useState(false);
  const [linkPromptPopup, setLinkPromptPopup] = useState(false);
  const [menuItem] = useState([
    {
      label: "Actions",
      children: [
        { label: ANSWER_OPTION_LABELS.LINK_OPTIONAL_EQUIPMENT },
        { label: ANSWER_OPTION_LABELS.ASSIGN_UNIQUE_CODE },
        ...(IS_LINK_PROMPT_ENABLED ? [{ label: ANSWER_OPTION_LABELS.LINK_PROMPT }] : []),
      ],
    },
  ]);

  const handleListItem = (event, child) => {
    if (child.label === ANSWER_OPTION_LABELS.LINK_OPTIONAL_EQUIPMENT) {
      setPopup(true);
    } else if (child.label === ANSWER_OPTION_LABELS.ASSIGN_UNIQUE_CODE) {
      setAssignUniqueCodePopup(true);
    } else if (child.label === ANSWER_OPTION_LABELS.LINK_PROMPT) {
      setLinkPromptPopup(true);
    }
  };

  const onCloseAssignUniqueCodePopup = () => {
    setAssignUniqueCodePopup(false);
  };

  const onClose = () => {
    setPopup(false);
  };

  const onCloseLinkPromptPopup = () => {
    setLinkPromptPopup(false);
  };

  return (
    <div ref={ref}>
      {menuItem.map(({ ...item }, mainIndex) => (
        <span id="menuSection" key={mainIndex}>
          <ListSubheader>
            <Typography
              variant="overline"
              component="div"
              style={{ marginTop: 5 }}
            >
              {item.label}
            </Typography>
          </ListSubheader>
          {item.children.map((child, index) => (
            <span id="menuOption" key={child.label}>
              <MenuItem>
                <ListItemText
                  primary={child.label}
                  onClick={(event) => handleListItem(event, child)}
                />
              </MenuItem>
              <Divider light className={classes.sideNavDivider} />
            </span>
          ))}
        </span>
      ))}
      <LinkOptionalEquipment
        open={popup}
        onClose={onClose}
        title="Link Optional Equipment"
      />
      {assignUniqueCodePopup && (
        <AssignUniqueCode onClose={onCloseAssignUniqueCodePopup} />
      )}
      {linkPromptPopup && (
        <LinkPrompt
          onClose={onCloseLinkPromptPopup}
          selectedPrompt={props.element.promptId || null}
        />
      )}
    </div>
  );
});

export default FileUploaderMenu;
